import PhotoTags from ".";

export const photoTagsRoutes = () => [
  {
    path:"/admin/photo-tags",
    component: PhotoTags,
    layout: "admin",
    routeType: "admin",
    title: "Photo Management",
  },
];
